/**
 * Telegram WebApp 6.0 does not support showPopup; recent telegram-web-app.js routes
 * showAlert (and similar) through showPopup → unhandled rejection and broken flows.
 */
export type TelegramWebAppLike = {
  version?: string;
  isVersionAtLeast?: (version: string) => boolean;
  showAlert?: (message: string) => void | Promise<void>;
  showConfirm?: (message: string, callback: (ok: boolean) => void) => void;
};

export function webAppPreferBrowserDialogs(webApp: TelegramWebAppLike | undefined): boolean {
  if (!webApp) return true;
  if (typeof webApp.isVersionAtLeast === 'function') {
    return !webApp.isVersionAtLeast('6.1');
  }
  const parts = (webApp.version || '0').split('.');
  const major = parseInt(parts[0] ?? '0', 10);
  const minor = parseInt(parts[1] ?? '0', 10);
  if (!Number.isFinite(major)) return true;
  if (major < 6) return true;
  if (major === 6 && minor === 0) return true;
  return false;
}

export function showAppAlert(webApp: TelegramWebAppLike | undefined, message: string): void {
  if (!webApp || webAppPreferBrowserDialogs(webApp)) {
    window.alert(message);
    return;
  }
  try {
    const ret = webApp.showAlert?.(message) as void | Promise<void> | undefined;
    if (ret != null && typeof (ret as Promise<void>).then === 'function') {
      (ret as Promise<void>).catch(() => window.alert(message));
    }
  } catch {
    window.alert(message);
  }
}

export function showAppConfirm(
  webApp: TelegramWebAppLike | undefined,
  message: string,
  callback: (ok: boolean) => void
): void {
  if (!webApp || webAppPreferBrowserDialogs(webApp)) {
    callback(window.confirm(message));
    return;
  }
  try {
    if (webApp.showConfirm) {
      webApp.showConfirm(message, callback);
    } else {
      callback(window.confirm(message));
    }
  } catch {
    callback(window.confirm(message));
  }
}
